import { render, staticRenderFns } from "./FormMessage.vue?vue&type=template&id=6238ce32&scoped=true"
import script from "./FormMessage.vue?vue&type=script&lang=js"
export * from "./FormMessage.vue?vue&type=script&lang=js"
import style0 from "./FormMessage.vue?vue&type=style&index=0&id=6238ce32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6238ce32",
  null
  
)

export default component.exports